import ApiRequestManagerInstance from '../ApiRequestManager';
import Channel from '../../classes/channel';
import { store } from '../../store/store';
import {
  IChannelRequest,
  IChannelsRequest,
} from '../../types/interfaces/channel';

export default function channelsRequest() {
  const promise = new Promise<{
    availableChannels: {
      visibleChannels: Channel[];
      hiddenChannels: Channel[];
    };
    unavailableChannels: Channel[];
  }>(async (resolve) => {
    try {
      const response: IChannelsRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'cdnSyncUrl',
          section: 'media',
          subsection: 'carrier',
          type: 'channels',
        },
      })) as unknown as IChannelsRequest;

      // Available channels

      const { user } = store.getState();
      let dialOffset = 1;

      const availableChannels = response.data
        .filter((channel: IChannelRequest) => channel.master.showWeb)
        // Filter adult channels
        .filter(
          (channel: IChannelRequest) =>
            !(
              channel.master.parentalControl
              // user.parental?.filterAdultChannels // Not available on Smart TV
            )
        )
        // Filter by postal code
        .filter((channel: IChannelRequest) => {
          if (user.isAnonymous) {
            return channel.master.scope === 'nacional';
          } else if (!user.isTest && channel.master.postalProvincia?.length) {
            return channel.master.postalProvincia.includes(
              user?.postalCode?.substring(0, 2) || ''
            );
          }
          return true;
        })
        // Filter channels not included in plan
        .filter((channel: IChannelRequest) => {
          if (!user.isAnonymous) {
            const isPlanIncluded = channel?.plans?.includes(user?.planId || '');
            const isExtraPlanIncluded =
              user?.extraPlans &&
              channel?.extraPlans?.some((channelExtraPlan) =>
                user?.extraPlans?.find(
                  (userExtraPlan) => userExtraPlan.id === channelExtraPlan
                )
              );
            if (!user.freemiumFilter) {
              return isPlanIncluded || isExtraPlanIncluded;
            }
          }
          return true;
        })
        // Map dials based on user order and add hidden flag
        .map((channel: IChannelRequest) => {
          let dial = channel.dial;
          let hidden = false;
          if (user.channelsOrder) {
            const userChannel = user.channelsOrder.find(
              (item) => item.channelCode === channel.channelCode
            );
            if (
              !userChannel?.dial &&
              user.channelsOrder.length
              //user.channelsOrder.find((item) => dial === item.dial) -> Keeps original dial = Dials are not contiguous
            ) {
              const baseDial =
                user.channelsOrder[user.channelsOrder.length - 1].dial;
              dial = dialOffset + baseDial;
              dialOffset += 1;
            } else {
              dial = userChannel?.dial || dial;
            }
            hidden = userChannel?.hidden ?? hidden;
          }
          channel.dial = dial;
          channel.hidden = hidden;
          return new Channel(channel);
        })
        .sort((a: Channel, b: Channel) => {
          return a.dial > b.dial ? 1 : -1;
        })

      // Unavailable channels

      const unavailableChannels = response.data
        .filter(
          (channel) =>
            !availableChannels.find((ch) => ch.code === channel.channelCode)
        )
        .map((ch) => {
          return new Channel(ch);
        });

      // Resolve parsed data

      resolve({
        availableChannels: {
          hiddenChannels: availableChannels.filter((item) => item.hidden),
          visibleChannels: availableChannels.filter((item) => !item.hidden),
        },
        unavailableChannels,
      });
    } catch (e) {
      console.error(e);
      resolve({
        availableChannels: { hiddenChannels: [], visibleChannels: [] },
        unavailableChannels: [],
      });
    }
  });

  return promise;
}
